<template>
    <div>
        <div class="page-top">
            <breadcrumb :main-name="mainName" :breadcrumbList="breadcrumbList"></breadcrumb>
            <a-button class="btn" type="primary" @click="editClient" v-if="userInfo.userType==2 || userInfo.userType === 7">编辑</a-button>
        </div>
        <div class="content-wrap">
           <div class="top">
               <h5>客户信息</h5>
               <a-row>
                   <a-row>
                       <a-col :span="9"><span>联系人：</span>{{clientData.customer.realName || '--'}}</a-col>
                       <a-col :span="8"><span>邮箱：</span>{{clientData.customer.email || '--'}}</a-col>
                       <a-col :span="7"><span>手机号码：</span>{{clientData.customer.phone || '--'}}</a-col>
                   </a-row>
                   <a-row>
                       <a-col :span="9"><span>账号：</span>{{clientData.customer.sName || '--'}}</a-col>
                       <a-col :span="8"><span>职位：</span>{{clientData.customer.position || '--'}}</a-col>
                       <a-col :span="7"><span>固定电话：</span>{{clientData.customer.telephone || '--'}}</a-col>
                   </a-row>
                   <a-row>
                       <a-col :span="9"><span>所在地：</span>{{clientData.customer.rName || '--'}}</a-col>
                       <a-col :span="8"><span>事业部：</span>{{clientData.customer.division || '--'}}</a-col>
                   </a-row>
               </a-row>
           </div>
            <div class="bottom">
                <h5>公司信息</h5>
                <a-row>
                    <a-row>
                        <a-col :span="9"><span>公司名称：</span>{{clientData.customer.cName || '--'}}</a-col>
                        <a-col :span="8"><span>公司品牌：</span>{{clientData.customer.bTitle || '--'}}</a-col>
                        <a-col :span="7"><span>行业：</span>{{clientData.customer.industryName || '--'}}</a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="9"><span>公司地址：</span>{{clientData.customer.cAddress || '--'}}</a-col>
                        <a-col :span="8"><span>所在城市：</span>{{clientData.customer.crName || '--'}}</a-col>
                        <a-col :span="7"><span>备注：</span>{{clientData.customer.cRemark || '--'}}</a-col>
                    </a-row>

                </a-row>
            </div>
        </div>
        <div class="bottom-btn">
            <a-button @click="back">返回</a-button>
        </div>
    </div>
</template>

<script>
    import breadcrumb from '../common/Breadcrumb.vue'
    import api from '../../commomFun/api.js'
    import timeFormat from '../../commomFun/timeFormat';
    export default{
        components: {
            breadcrumb,
        },
        data(){
            return {
                // 面包屑
                breadcrumbList: [
                    {
                        name: '客户管理',
                        path: '/clientList'
                    },
                    {
                        name: '客户详情',
                        path: ''
                    }
                ],
                mainName:'客户详情',
                clientData:{
                    brandList:{},
                    customer:{}
                },
                userInfo:'',
            }
        },
        mounted(){
            this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            this.getClientDetail()
        },
        methods: {
            //获取客户详情
            getClientDetail(){
                let clientId = sessionStorage.getItem('clientId')
                api.getApi('/customerManager/detail',{customerId:clientId}).then(res=>{
                    if(res.data.code==200){
                        this.clientData = res.data.data
                        let a = res.data.data.brandList.map((item)=>{
                            return item.bTitle
                        })
                        this.clientData.customer.bTitle = a.join(',')
                        console.log(this.clientData);
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            },
            //编辑客户信息
            editClient(){
                let obj = {
                    isEdit:true,
                    data:this.clientData
                }
                sessionStorage.setItem('clientData',JSON.stringify(obj))
                this.$router.push('./createClient')
            },
            //返回
            back(){
                this.$router.push('./clientList')
            }
        }
    }
</script>
<style scoped>
    .page-top {
        position: relative;
        margin-bottom: 24px;
    }

    .btn {
        position: absolute;
        right: 24px;
        bottom: 14px;
    }
    .content-wrap{
        margin: 0 24px;
        background: #fff;
        padding: 24px 32px;
    }
    .content-wrap h5{
        color:rgba(0,0,0,0.85);
        font-size: 16px;
        margin-bottom: 16px;
    }
    .content-wrap .ant-row{
        margin-bottom: 14px;
        color:rgba(0,0,0,0.65);
    }
    .content-wrap .ant-row span{
        color:rgba(0,0,0,0.85);
    }
    .bottom-btn{
        width: 100%;
        text-align: center;
        margin-top: 24px;
    }
    .top{
        padding-bottom: 16px;
        border-bottom: 1px solid #E8E8E8;
    }
    .bottom{
        padding-top: 32px;
    }
</style>